import { filter, isEmpty } from 'lodash/fp';

import ProductService from '../../models/product';

// Fetches products based on id's and filters them based on scale and state
// @ts-expect-error - Automatic, Please fix when editing this file
const getFilteredProducts = ({ customer, productIds, products }) => {
  // Get the products.
  const { scale, state } = customer;
  const resolvedProducts = ProductService.getProducts(products, productIds);

  // Remove products based on customer state and scale.
  const filteredByStateAndScale = filter(
    (product) => ProductService.isAvailableIn(product, state) && ProductService.isAvailableFor(product, scale),
    resolvedProducts,
  );

  // If we have no products left or we get an error, bail.
  if (isEmpty(filteredByStateAndScale) || products?.error) {
    return null;
  }

  return filteredByStateAndScale;
};

export default getFilteredProducts;
